import { welcomePart1Topics } from './welcomePart1';
import { welcomePart2Topics, welcomeQuiz } from './welcomePart2';
import { snafPart1Topics } from './snafPart1';
import { snafPart2Topics } from './snafPart2';

export const welcomeModule = {
  id: 'welcome',
  title: 'Welcome to ServiceNow',
  description: 'Get introduced to the ServiceNow platform, its core capabilities, and the tools you will use throughout your ServiceNow career.',
  icon: 'BookOpen',
  topics: [...welcomePart1Topics, ...welcomePart2Topics],
  quiz: welcomeQuiz,
};

const snafModule = {
  id: 'snaf',
  title: 'ServiceNow Administration Fundamentals',
  description: 'Deep-dive into ServiceNow administration covering modernized work experience, platform power, application configuration, data management, self-service, productivity, testing, security, and a capstone project.',
  icon: 'Settings',
  topics: [...snafPart1Topics, ...snafPart2Topics],
};

export const courseModules = [welcomeModule, snafModule];

export const getAllSections = () => {
  const sections = [];
  courseModules.forEach((mod) => {
    mod.topics.forEach((topic) => {
      if (topic.subtopics) {
        topic.subtopics.forEach((sub) => {
          sections.push({
            ...sub,
            moduleName: mod.title,
            topicName: topic.title,
            moduleId: mod.id,
            topicId: topic.id,
          });
        });
      }
      if (topic.quiz) {
        sections.push({
          id: topic.quiz.id,
          title: topic.quiz.title,
          type: 'quiz',
          moduleName: mod.title,
          topicName: topic.title,
          moduleId: mod.id,
        });
      }
    });
    if (mod.quiz) {
      sections.push({
        id: mod.quiz.id,
        title: mod.quiz.title,
        type: 'quiz',
        moduleName: mod.title,
        moduleId: mod.id,
      });
    }
  });
  return sections;
};

export const getTotalSections = () => {
  let count = 0;
  courseModules.forEach((mod) => {
    mod.topics.forEach((topic) => {
      if (topic.subtopics) count += topic.subtopics.length;
      if (topic.quiz) count += 1;
    });
    if (mod.quiz) count += 1;
  });
  return count;
};
